const codeLangs = [
  "Auto",
  "Plaintext",
  "Markdown",
  "JSON",
  "JavaScript",
  "TypeScript",
  "HTML",
  "XML",
  "YAML",
  "CSS",
  "Less",
  "Swift",
  "ObjectiveC",
  "Python",
  "PHP",
  "Perl",
  "Java",
];

export default codeLangs;
